import { SET_ERROR_MESSAGES, SET_ERROR_MESSAGES_LOADING } from '../storeConstants';

const initialState = {
    messagesByCode: {},
    isLoading: false,
    isLoaded: false,
};

const errorMessagesReducer = (state = initialState, action) => {
    switch (action.type) {
        case SET_ERROR_MESSAGES_LOADING:
            return {
                ...state,
                isLoading: action.payload,
            };
        case SET_ERROR_MESSAGES:
            return {
                ...state,
                messagesByCode: action.payload,
                isLoading: false,
                isLoaded: true,
            };
        default:
            return state;
    }
};

export default errorMessagesReducer;
